<template>
    <div class="employeeSettings">
        <!-- Tab content area -->

        <div class="col-sm-12 o-no-padding c-responsive-fixwidth">

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('formatting') }}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('date_format') }}:</h6>
                                        <div :class="{'isDisabled':!getPower('editEmployee')}" class="o-cutsomSelect">
                                            <select v-model="employeeData.date_format" @change="dateSelect()" >
                                                <option v-for="(date,index) in dateFormat" :key="index" :value="date">{{date}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleDate}}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('time_format') }}:</h6>
                                      <!-- <p class="h5-v2">12 Hour Clock</p> -->
                                      <div :class="{'isDisabled':!getPower('editEmployee')}" class="o-cutsomSelect">
                                           <select v-model="employeeData.time_format" @change="timeSelect()">
                                                <option v-for="(time,index) in timeFormat" :key="index" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleTime}}</h6>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="col-sm-6 o-left-padding-only">

                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">Phone format:</h6>
                                        <p class="h5-v2">xxxyyyzzzz</p>
                                    </li>
                                </ul>

                            </div> -->
                        </div>

                    </div>
                </div>
            </div>

            <!-- #1720 Carpool — opt-in + pickup for this employee. Editable with the
                 editEmployee power; read-only (display) otherwise. Mirrors the card
                 under My Profile > Settings, but targets this employee's user_id. -->
            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('car_pooling') }}:</h2>
                            <p class="ps2">{{ $t('car_pooling_info1') +  $t('car_pooling_info2') }}</p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <div :class="{'isDisabled':!getPower('editEmployee')}">
                                    <ul class="c-skillset">
                                        <li>
                                            <label class="o-carpool-optin">
                                                <input type="checkbox" v-model="carpool.opt_in" :disabled="!getPower('editEmployee')" @change="saveCarpool()" />
                                                <span>I can provide transportation</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div v-if="carpool.opt_in" class="o-carpool-pickup">
                                        <h6 class="h6">Pickup location</h6>
                                        <label class="o-carpool-radio">
                                            <input type="radio" value="home" v-model="carpool.pickup_source" :disabled="!getPower('editEmployee')" @change="saveCarpool()" />
                                            <span>Use address on file<small v-if="carpool.home && carpool.home.address"> — {{ carpool.home.address }}</small></span>
                                        </label>
                                        <p v-if="carpool.pickup_source === 'home' && carpool.home && !carpool.home.verified" class="o-carpool-warn">
                                            This address isn't pin-verified yet — choose a different pickup address to set a pin.
                                        </p>
                                        <label class="o-carpool-radio">
                                            <input type="radio" value="custom" v-model="carpool.pickup_source" :disabled="!getPower('editEmployee')" />
                                            <span>Use a different pickup address</span>
                                        </label>
                                        <div v-if="carpool.pickup_source === 'custom'" class="o-carpool-custom">
                                            <input type="text" class="form-control" v-model.trim="carpool.pickup_address" :disabled="!getPower('editEmployee')" placeholder="Pickup address (street, city, state)" />
                                            <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue" :disabled="!getPower('editEmployee') || !carpool.pickup_address" @click="openCarpoolPin()">
                                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                                                {{ carpool.pickup_verified ? "Pin confirmed — adjust" : "Set pin on map" }}
                                            </button>
                                            <p v-if="carpool.pickup_lat" class="o-carpool-coords">
                                                {{ Number(carpool.pickup_lat).toFixed(6) }}, {{ Number(carpool.pickup_lng).toFixed(6) }}
                                                <span v-if="!carpool.pickup_verified"> (unconfirmed)</span>
                                            </p>
                                        </div>
                                        <button type="button" class="btn c-solid-btn c-solid-btn--green o-carpool-save" :disabled="!getPower('editEmployee') || carpoolSaving" @click="saveCarpool()">
                                            <i class="fa fa-save" aria-hidden="true"></i> Save carpool settings
                                        </button>
                                    </div>
                                </div>

                                <!-- #1720 pickup pin confirm (reuses the #1715 VenuePinMap). -->
                                <modal name="emp-carpool-pin" :width="560" height="auto" :adaptive="true" @closed="carpoolPinShow = false">
                                    <div class="o-carpool-pin-modal">
                                        <h5 class="c-common-heading">Is this pickup location correct?</h5>
                                        <VenuePinMap
                                            v-if="carpoolPinShow"
                                            :address="carpool.pickup_address"
                                            :lat="carpool.pickup_lat ? Number(carpool.pickup_lat) : null"
                                            :lng="carpool.pickup_lng ? Number(carpool.pickup_lng) : null"
                                            :source="carpool.pickup_coords_source"
                                            :draggable="carpoolPinDraggable"
                                            :zoom="17"
                                            @update:coords="onCarpoolCoords" />
                                        <div class="o-carpool-pin-actions">
                                            <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue" @click="closeCarpoolPin()">Cancel</button>
                                            <template v-if="!carpoolPinDraggable">
                                                <button type="button" class="btn c-solid-btn c-solid-btn--green" @click="confirmCarpoolPin()">That's correct</button>
                                                <button type="button" class="btn c-common-btn c-common-btn--inverse-icon-blue" @click="carpoolPinDraggable = true">Move pin</button>
                                            </template>
                                            <button v-else type="button" class="btn c-solid-btn c-solid-btn--green" @click="confirmCarpoolPin()">Save this location</button>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                        
                            <!-- <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('ICS_calendar_link') }}:</h6>
                                        <div class="col-md-12">
                                            <p class="h5-v2">{{ $t('generate_ics_link_note') }}</p>
                                            <div :class="{'isDisabled':!getPower('editEmployee')}" class="o-employe-view">
                                                <a href="javascript: void(0)" @click="generateLink()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> {{ $t('generate_link' )}}</a>
                                            </div>
                                            <p class="h5-v2">{{$t('generated_ics_link_copy_note')}}</p>
                                            <input :class="{'isDisabled':!getPower('editEmployee')}" type="text" v-model="ics_link" class="form-control o-capitalize-field" :placeholder="$t('ICS_calendar_link')">
                                        </div>
                                        
                                    </li>
                                </ul>
                            </div> -->

                        </div>

                        <!-- #1516 Nylas Calendar Integration removed from EditEmployee>Settings (ed 2026-06-28); backend service retires under #1523 -->

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('notifications') }}:</h2>
                            <p class="ps2">{{ $t('select_notify_channel') }}</p>
                            <p v-if="clientData && clientData.suppress_sms" style="color: #e6a23c; font-size: 12px; margin-top: 4px;"><i class="fa fa-exclamation-triangle"></i> SMS notifications disabled at client level</p>
                        </div>
                        <div v-if="!clientData" class="col-sm-12 text-center" style="padding: 15px;"><i class="fa fa-spinner fa-spin"></i></div>
                        <div v-else class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul :class="{'isDisabled':!getPower('editEmployee')}" class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <!-- <label> -->
                                                <!-- <input type="radio" name="notifyChck" value="app" v-model="pickedNotify" @change="changeNotificationSettings()"> -->

                                                <el-switch
                                                    v-model="notifyApp"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    @change="changeNotifyToApp()"
                                                    >
                                                </el-switch>
                                                    {{ $t('app') }}
                                            <!-- </label> -->
                                        </div>
                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                APP
                                                <input type="checkbox" name="o4" v-model="employeeData.app_notification" @change="changeAppNotification()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <!-- <label>                                                -->
                                                <!-- <input type="radio" name="notifyChck" value="email" v-model="pickedNotify" @change="changeNotificationSettings()"> -->
                                                <el-switch
                                                    v-model="notifyEmail"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    @change="changeNotifyToEmail()"
                                                    >
                                                </el-switch>                                                
                                                    {{ $t('email_primary') }}
                                            <!-- </label> -->
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                Email(primary)
                                                <input type="checkbox" name="o4" v-model="employeeData.email_notification" @change="emailNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                    <li v-if="!isCallstewardUK()">
                                       <div class="radio o-custom-radio">
                                            <!-- <label> -->
                                                <!-- <input type="radio" name="notifyChck" value="sms" v-model="pickedNotify" @change="changeNotificationSettings()"> -->
                                                <el-switch
                                                    v-model="notifySms"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value = 1
                                                    :inactive-value = 0
                                                    :disabled="!!(clientData && clientData.suppress_sms)"
                                                    @change="changeNotifyToSms()"
                                                    >
                                                </el-switch>
                                                    {{$t('sms_cell') }}
                                                    <span v-if="clientData && clientData.suppress_sms" style="color: #999; font-size: 11px;">(disabled by admin)</span>
                                            <!-- </label> -->
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                SMS(cell)
                                                <input type="checkbox" name="o4" v-model="employeeData.sms_notification" @change="smsNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-12">
                                <h2 class="h2" v-if="isCallstewardUK()">Stop Email:</h2>
                                <h2 class="h2" v-else>{{ $t('stop_email_sms') }}</h2>
                                    <!-- <p class="ps2">Do you want to stop receive email and sms?.</p>
                                    <el-switch
                                        v-model="notifyLock"
                                        @change="notifyStartStop()"
                                        style="display: block"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6">
                                    </el-switch> -->
                            </div>
                            <div class="col-sm-12 o-left-padding-only">
                                <ul :class="{'isDisabled':!getPower('editEmployee')}" class="c-skillset c-skillset--profile">

                                    
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>                                               
                                                <input type="radio" name="notifStop" :value="false" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('receive') }}
                                            </label>
                                        </div>

                                    </li>
                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="true" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('STOP') }}
                                            </label>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-12" >
                            
                        </div>

                        <!-- <div class="col-md-12" v-if="getLogsAccess()">
                            <div>
                                <h2 class="h2">{{ $t('navigation_history') }}:</h2>
                                <p class="ps2">{{ $t('navigation_notification_note') }}</p>
                            </div>
                            <div class="o-employe-view">
                                <a href="javascript: void(0)" @click="notifyHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i> {{ $t('click_to_view') }}</a>
                            </div>
                        </div> -->

                        <div class="col-md-12" v-if="mailing_list_visibility_flag">
                            <div>
                                <h2 class="h2">Announcements from other IATSE Locals: </h2>
                                <!-- <p class="ps2">{{ $t('navigation_notification_note') }} </p> -->
                            </div>
                            <div class="o-employe-view">
                                <el-switch
                                    v-model="mailing_action"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value = 1
                                    :inactive-value = 0
                                    @change="changeMailingAction()"
                                    >
                                </el-switch>
                                An Email List
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('login_options') }}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="twoFactorAuth" :checked="two_factor_auth" @click="changeSignInOptions2fa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('2fa_authentication') }}
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>                                               
                                                <input type="radio" name="fingerPrintAuth" :checked="finger_print_auth" @click="changeSignInOptionsFpa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> 
                                                {{ $t('finger_print_authentication') }}
                                                {{ $t('google_ios_authorization') }}
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="col-sm-3 o-no-padding">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">Notifications:</h2>
                            <p class="ps2">Your .ics calendar file is located at:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="ps2">If shifts are imported incorrectly, try the UTC calendar:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>

        <!-- /Tab content area -->
    </div>
</template>
<script>
    // import { global } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    // import { bus } from '../../main';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    import { loadStripe } from '@stripe/stripe-js';
    import VenuePinMap from '../venue/VenuePinMap.vue'; // #1720 carpool pickup pin editor


    export default {
        components: {
            // StripeCheckout
            VenuePinMap,
        },
        data() {
            return {
                // #1720 carpool profile for THIS employee (targets employable.id).
                carpool: {
                    opt_in: false,
                    pickup_source: 'home',
                    pickup_address: null,
                    pickup_lat: null,
                    pickup_lng: null,
                    pickup_verified: false,
                    pickup_coords_source: null,
                    home: null,
                },
                carpoolSaving: false,
                carpoolPinShow: false,
                carpoolPinDraggable: false,
                stripe: null,
                stripe_customer_id: '',
                is_nylas_subscription_active: false,
                nylas_subscription: null,
                employeeEmail: '',
                cur_employee_id: null,
                dataAvailable: false,
                lineItems: [
                    {
                    price: 'price_1Kb4d6JTPH63iEDVOv4sJ7jk', // The id of the recurring price you created in your Stripe dashboard
                    quantity: 1
                    },
                ],
                successURL: window.location.href.split('#')[0]+"#/stripe-success",
                cancelURL: window.location.href,
                loading: false,
                publishableKey: 'pk_test_51KUWweJTPH63iEDVqvqaGAnZEGmq5j1sBWwaJN5jv5aD7tJmurH3x7kpOro0HSxyjAhKAJbNJmDsQsU9uunmZMVo00ynpHuSnW',
                able_to_access_logs: null,
                notifyApp: false,
                notifyEmail: false,
                notifySms: false,
                two_factor_auth: false,
                finger_print_auth: false,
                pickedNotify: 'sms',
                notifyLock:'no',
                ics_link:'',
                exampleDate: moment(Date.now()).format("DD MMMM YYYY"),
                dateFormat: [
                    "MM-DD-YY",
                    "MM/DD/YYYY",
                    "MMM DD YYYY",
                    "MMMM DD YYYY",
                    "DD-MM-YY",
                    "DD-MM-YYYY",
                    "DD MMM YYYY",
                    "DD MMMM YYYY",
                    "YYYY-MM-DD",
                    "YYYY MMM DD",
                    "YYYY MMMM DD",
                ],
                exampleTime: moment(Date.now()).format("hh:mm a"),
                timeFormat: [
                    "hh:mm a",
                    "HH:mm",
                ],
                selectDate: '',
                selectTime: '',
                employeeData: [],
                mailing_action: 0,
                clientData: null,
                mailing_list_visibility_flag: false
            }
        },
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                userID: 'userID',
                getNylasUserEmail: 'getNylasUserEmail'
                // currentEmployeeID: 'currentEmployeeID',
                // getNotificationType: 'getNotificationType',
            })
        },
        methods: {
            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },
            async changeMailingAction() {
                let result = this.mailing_action ? 'subscribe' : 'unsubscribe';
                console.log(this.mailing_action, result);
                await service.put('employee/'+ this.employeeData.employable.id + '/updateMailingList',{
                    mailing_action: result
                }, {
                    'Authorization': this.userToken
                }).then((res) => {
                    if(res.data) {
                        console.log(res.data);
                        this.$notify.success({
                                message: res.data.message,
                                title: 'Success'
                            }
                        );
                    }       
                }).catch((err) => {
                    console.log(err);
                    this.$notify(
                        {
                            type: 'error',
                            message: 'Something went wrong',
                            title: 'Error'
                        }
                    );
                    
                });
            },
            getMailingListStatus() {
                service.get('employee/'+ this.employeeData.employable.id +'/checkUserSubscriptionStatus', {
                    'Authorization': this.userToken,
                })
                .then((res) => {
                    this.mailing_action=res.data;
                    // console.log(res.data);
                    // this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },
            generateNylasLink() {
                service.get('employee/authorizeNylas', {
                    'Authorization': this.userToken,
                    'user-id': this.userID,
                    'email': this.getNylasUserEmail
                }).then((res) => {
                    // console.log(res.data.result);
                    if(res.data&&res.data.result) {
                        window.location.href = res.data.result;
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: 'Nylas Subscription Started. Thank you for being with us!'
                        });
                    }
                    
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getEmailProvider() {
                await service.get('employee/detectNylasProvider', {
                    'Authorization': this.userToken,
                    'email': this.getNylasUserEmail
                }).then((res) => {
                    if(res.data&&res.data.result&&res.data.result=='gmail') {  
                        this.$router.push({
                            path: "/sign-in-with-google",
                            name: 'signInWithGoogle'
                        });
                    }else {
                        this.generateNylasLink()
                    }        
                }).catch((err) => {
                    console.log(err);
                });
            },

            getLogsAccess(){
                if(this.able_to_access_logs || this.userRoleSlug != 'employee'){
                    return true;
                }
                return false;
            },

            refreshSubscription() {
                console.log("Refresh Nylas Subscription");
                this.$notify({
                    type: 'success',
                    title: this.$t('success'),
                    message: 'Nylas Integration Refreshed'
                });
            },
            tokenCreated(token) {
                console.log(token)
            },

            async submit () {
                if(this.employeeEmail=='' || this.errors.has('email')) {
                    this.$notify.error({
                        message: "Valid Email is required to proceed",
                        title: "Required"
                    });
                    return;
                }
                this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                // console.log(this.getNylasUserEmail);
                if(this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    this.generateNylasLink();
                    // await this.getEmailProvider();
                } else {
                    // You will be redirected to Stripe's secure checkout page
                    this.$refs.checkoutRef.redirectToCheckout();
                }
            },

            async handleCheckout() {
                this.loading = true;
                if(this.employeeEmail=='' || this.errors.has('email')) {
                    this.$notify.error({
                        message: "Valid Email is required to proceed",
                        title: "Required"
                    });
                    return;
                }
                this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                console.log(this.employeeData);
                if(this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    this.generateNylasLink();
                    // await this.getEmailProvider();
                }else {
                    try {
                        let headers = { 
                            // 'authorization': this.userToken
                        }
                        let body = {
                            // userId: this.userID, // Pass user-related data here
                            line_items: {
                                price: 'price_1Kb4d6JTPH63iEDVOv4sJ7jk', // The id of the recurring price you created in your Stripe dashboard
                                quantity: 1
                            },
                            success_url: this.successURL,
                            cancel_url: this.cancelURL,
                            customer_id: this.stripe_customer_id,
                            client_reference_id: this.userID,
                            allow_promotion_codes: "true"
                        }
                        console.log("Body: ......................", body);
                        const response = await service.post('employee/create-stripe-session', body, headers );
                        console.log("Session ID: ......................", response.data);
                        const { sessionId } = response.data;
                        console.log(sessionId);
                        const { error } = await this.stripe.redirectToCheckout({ sessionId });
                        if (error) console.error('Stripe Checkout Error:', error);
                        } catch (error) {
                            console.error("Error during checkout:", error);
                        } finally {
                            this.loading = false;
                        }
                }
            },

            async cancelSubscription() {
                this.$confirm('Are you sure you would like to cancel the Subscription? ', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                }).then(async() => {
                    // Cancel Stripe Subscription
                    this.dataAvailable = false;
                    await service.post('employee/cancelStripeSubscription',{
                    user_id: this.userID
                    }, {
                        'Authorization': this.userToken
                    }).then((res) => {
                        console.log(res.data);
                        if(res.data) {                   
                            this.$notify({
                                type: 'success',
                                title: this.$t('success'),
                                message: res.data.status_message
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });

                    // Cancel Nylas Subscription
                    await service.post('employee/cancelNylasSubscription',{
                    user_id: this.userID
                    }, {
                        'Authorization': this.userToken
                    }).then(async(res) => {
                        if(res.data) {                   
                            this.$notify({
                                type: 'success',
                                title: this.$t('success'),
                                message: res.data.status_message
                            });
                        }
                        await this.getEmpDetails();
                        this.dataAvailable = true;
                    }).catch((err) => {
                        console.log(err);
                    });
                    
                }).catch((error) => {
                    console.log(error);
                    this.getEmpDetails();
                });
            },
            // changeNotifyToApp() {
            //     console.log(this.notifyApp)
            // },
            // changeNotifyToEmail() {
            //     console.log(this.notifyEmail)
            // },
            // changeNotifyToSms() {
            //     console.log(this.notifySms)
            // },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            isCallstewardUK(){
                return dateTimeConvert.isCallstewardUK();
            },
            notifyHistory(){
                this.$store.dispatch('setNotificationType', 'employeeHistoryAction');
                this.$router.push({
                    path: `/notifyLog/`+ btoa(this.employeeData.id)
                });
            },
            dateSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'date',
                    'format_string': this.employeeData.date_format
                }
                this.exampleDate = moment(Date.now()).format(this.employeeData.date_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,

                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("date_format", this.employeeData.date_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });

            },
            generateLink(){
                service.get('call/calendar/'+this.employeeData.id, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res.data.result.calendar_file);
                    this.ics_link=res.data.result.calendar_file;
                    
                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: this.$t('file_not_found')
                    });
                });
            },
            timeSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'time',
                    'format_string': this.employeeData.time_format
                }
                this.exampleTime = moment(Date.now()).format(this.employeeData.time_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("time_format", this.employeeData.time_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });
            },
            changeNotificationSettings(){
                // console.log(this.pickedNotify);
                // if(this.pickedNotify=='email'){
                //     this.emailNotificationSettings();
                // }else{
                //     this.smsNotificationSettings();
                // }
                this.emailNotificationSettings();
                this.smsNotificationSettings();
                this.changeAppNotification();
                this.$store.dispatch('setNotificationType', this.pickedNotify);
            },
            // changeAppNotification() {
            changeNotifyToApp() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyApp = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyApp,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/appNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // emailNotificationSettings() {
            changeNotifyToEmail() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyEmail = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyEmail,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/emailNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res); 
                        //bus.$emit('onUpdateOrAdd', 'On update notifications settings');
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // smsNotificationSettings() {
            changeNotifyToSms() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifySms = 1
                    return;
                } else {
                    // console.log("Sms Notify Else")
                    var formData = {
                        'status': this.notifySms,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/smsNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            notifyStartStop(){
                var formData ={
                    'employee_id': this.employeeData.id,
                    'status': this.notifyLock
                };
                // console.log(formData);
                
                service.post('employee/stopNotificationSettings', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: this.$t('success')
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },
            changeSignInOptions2fa() {
               
                this.two_factor_auth = !this.two_factor_auth;
                // console.log('2FA:'+this.two_factor_auth);
                // console.log(this.employeeData.employable.id, this.userID);

                var formData = {
                    'status': this.two_factor_auth ? 1 : 0,
                    'user_id': this.employeeData.employable.id
                };
                // console.log(formData);

                service.post('employee/twoFactorAuthSettings', formData, {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$notify({
                        title: this.$t('Success'),
                        message:this.$t('login_option_updated'),
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message: this.$t('something_went_wrong'),
                        type: 'error'
                    });
                    console.log(err);
                });
            },

            changeSignInOptionsFpa() {
                // console.log('FPA:'+this.finger_print_auth);
                this.finger_print_auth = !this.finger_print_auth;
                var formData = {
                    'status': this.finger_print_auth ? 1 : 0,
                    'user_id': this.employeeData.employable.id
                };
                // console.log('FPA:'+this.finger_print_auth);
                // console.log(formData);
            },
            // ── #1720 Carpool (targets this employee's user_id) ──────────
            carpoolHeaders() {
                return {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                };
            },
            carpoolTargetId() {
                return (this.employeeData && this.employeeData.employable) ? this.employeeData.employable.id : null;
            },
            async loadCarpool() {
                const uid = this.carpoolTargetId();
                if (!uid) return;
                try {
                    const res = await service.get('carpool?user_id=' + uid, this.carpoolHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.carpool.opt_in = !!r.opt_in;
                    this.carpool.pickup_source = r.pickup_source || 'home';
                    this.carpool.pickup_address = r.pickup_address || null;
                    this.carpool.pickup_lat = r.pickup_lat != null ? r.pickup_lat : null;
                    this.carpool.pickup_lng = r.pickup_lng != null ? r.pickup_lng : null;
                    this.carpool.pickup_verified = !!r.pickup_verified;
                    this.carpool.pickup_coords_source = r.pickup_verified
                        ? 'manual' : (r.pickup_lat != null ? 'geocoded' : null);
                    this.carpool.home = r.home || null;
                } catch (e) { console.log('loadCarpool error:', e); }
            },
            async saveCarpool() {
                if (!this.getPower('editEmployee')) return;
                const uid = this.carpoolTargetId();
                if (!uid) return;
                this.carpoolSaving = true;
                try {
                    const payload = {
                        user_id: uid,
                        opt_in: this.carpool.opt_in,
                        pickup_source: this.carpool.pickup_source,
                        pickup_address: this.carpool.pickup_address,
                        lat: this.carpool.pickup_lat,
                        lng: this.carpool.pickup_lng,
                        coords_source: this.carpool.pickup_coords_source,
                        coords_verified: this.carpool.pickup_verified,
                    };
                    const res = await service.post('carpool', payload, this.carpoolHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.carpool.pickup_source = r.pickup_source || this.carpool.pickup_source;
                    this.carpool.pickup_address = r.pickup_address || null;
                    this.carpool.pickup_lat = r.pickup_lat != null ? r.pickup_lat : null;
                    this.carpool.pickup_lng = r.pickup_lng != null ? r.pickup_lng : null;
                    this.carpool.pickup_verified = !!r.pickup_verified;
                    this.carpool.home = r.home || this.carpool.home;
                    this.$notify({ title: 'Saved', message: 'Carpool settings updated.', type: 'success' });
                } catch (e) {
                    console.log('saveCarpool error:', e);
                    this.$notify.error({ title: 'Error', message: 'Could not save carpool settings.' });
                } finally { this.carpoolSaving = false; }
            },
            openCarpoolPin() {
                this.carpoolPinDraggable = false;
                this.carpoolPinShow = true;
                this.$modal.show('emp-carpool-pin');
            },
            closeCarpoolPin() {
                this.carpoolPinShow = false;
                this.carpoolPinDraggable = false;
                this.$modal.hide('emp-carpool-pin');
            },
            onCarpoolCoords({ lat, lng, source }) {
                this.carpool.pickup_lat = lat;
                this.carpool.pickup_lng = lng;
                this.carpool.pickup_coords_source = source;
            },
            confirmCarpoolPin() {
                this.carpool.pickup_verified = true;
                this.carpoolPinShow = false;
                this.carpoolPinDraggable = false;
                this.$modal.hide('emp-carpool-pin');
            },
            async getEmpDetails() {
                // this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                await service.get('employee/' + this.cur_employee_id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        //this.employeeData = basic.data.result;
                        this.employeeData = res.data.result;
                        this.nylas_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.nylas_subscription?this.employeeData.employable.nylas_subscription:null;

                        this.is_nylas_subscription_active=this.nylas_subscription?this.nylas_subscription.is_active:false;

                        this.employeeEmail = this.nylas_subscription && this.nylas_subscription.email_address ? this.nylas_subscription.email_address:'';
                        this.dataAvailable = true;
                        this.$forceUpdate();
                        // this.userImage = this.detailEmployee.employable;
                        //console.log("PATH", this.getBaseURL + this.detailEmployee.employable.image);
                        //console.log("PATH", this.getBaseURL);
                        //console.log("DATA", this.detailEmployee.employable.image);
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            async getClientData() {
                var clientId = this.userClientID;
                if (!clientId && this.employeeData && this.employeeData.client_employee && this.employeeData.client_employee.client_id) {
                    clientId = this.employeeData.client_employee.client_id;
                }
                if (!clientId) {
                    console.warn('getClientData: no clientId available');
                    return;
                }
                await service.get('client/' + clientId, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.mailing_list_visibility_flag = this.clientData.mailing_list_visibility_flag;
                }).catch((err) => {
                    console.log('getClientData error:', err);
                });
            },
        },


        async created() {
            this.cur_employee_id = this.empDetails ? this.empDetails.id : atob(this.$route.params.empId);
            await this.getEmpDetails();
            await this.getClientData();
            // this.stripe_customer_id = 'cus_ROMD8AUwb2ORQH';
            console.log("Stripe Customer Id ..............................",this.stripe_customer_id);
            this.employeeData = this.empDetails;
            this.stripe = await loadStripe(this.publishableKey);
            this.stripe_customer_id = this.employeeData&&this.employeeData.employable && this.employeeData.employable.stripe_customer_id ? this.employeeData.employable.stripe_customer_id : "";
            console.log("Stripe Customer Id ..............................",this.stripe_customer_id);
            this.cur_employee_id = this.empDetails?this.empDetails.id:atob(this.$route.params.empId);
            this.able_to_access_logs = this.employeeData&&this.employeeData.employee_status?this.employeeData.employee_status.able_to_access_logs:false;
            // console.log(this.employeeData)
            // console.log(this.able_to_access_logs);
            // this.pickedNotify = (this.employeeData.email_notification==1)? 'email':(this.employeeData.sms_notification==1)?'sms':(this.employeeData.app_notification==1)?'app':'';
            this.notifyApp = this.employeeData.app_notification
            this.notifyEmail = this.employeeData.email_notification
            this.notifySms = this.employeeData.sms_notification
            this.notifyLock=(this.employeeData.stop_notification==0)?false:true;
            this.loadCarpool(); // #1720 carpool profile for this employee
            this.two_factor_auth = this.employeeData.employable.two_factor_auth ? true : false;
            this.getMailingListStatus();
        }
    }

</script>
<style scoped>
.notify-icon {
    margin:10px 10px 10px 0;
}
.nylas-logo {
    height: 25px;
    width: 60px;
    padding: 8px 5px 0;
}
.nylas-event {
    font-size: 16px;        
    border-radius: 5px;
    text-decoration: none!important;
    padding: 12px 10px 5px;
    /* color: #8158b8!important;        
    border: 1px solid #8158b8; */
}
.nylas-event.active {       
    background-color: #8158b8!important;        
    border: 1px solid #8158b8;
}
.nylas-event.active:hover {       
    color: #8158b8!important;        
    border: 1px solid #8158b8;
}
.nylas-subscribe-button {
    margin: 15px 10px 10px 0;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #258325;
    color: #ffffff;
    font-size:13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-cancel-block {
    /* margin: 15px 10px 10px 0; */
    display: flex;
    align-items: flex-start;
    flex-direction: row;
}
.nylas-subscription-label{
    padding: 6px 5px 10px 20px;
    margin-top: 10px;
    /* margin-bottom: 10px; */
    border: none;
    outline: none;
    background-color: #ffffff;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
}
.nylas-cancel-button {
    padding: 10px 20px;
    margin: 10px;
    border: none;
    outline: none;
    background-color: #e7eee7;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-refresh-button {
    /* margin: 15px 10px 10px 0; */
    margin: 10px;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #FB9803;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
/* #1720 Carpool card */
.o-carpool-optin { display: flex; align-items: center; gap: 8px; cursor: pointer; font-weight: 600; margin: 0; }
.o-carpool-optin input[type="checkbox"] { width: auto; margin: 0; flex: 0 0 auto; }
.o-carpool-pickup { margin-top: 10px; }
.o-carpool-pickup .h6 { margin-bottom: 6px; }
.o-carpool-radio { display: flex; align-items: center; gap: 8px; cursor: pointer; margin: 6px 0; font-weight: 400; }
.o-carpool-radio input[type="radio"] { width: auto; margin: 0; flex: 0 0 auto; }
.o-carpool-warn { font-size: 12px; color: #9a6a00; margin: 4px 0 4px 22px; }
.o-carpool-custom { margin: 8px 0 8px 22px; display: flex; flex-direction: column; gap: 8px; align-items: flex-start; }
.o-carpool-custom .form-control { max-width: 320px; }
.o-carpool-coords { font-size: 12px; color: #6b7280; margin: 0; }
.o-carpool-save { margin-top: 10px; }
.o-carpool-pin-modal { padding: 14px; }
.o-carpool-pin-actions { display: flex; gap: 8px; justify-content: center; margin-top: 12px; flex-wrap: wrap; }
</style>
